/**
 * 模板管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>模板管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索"></el-form-item> -->
       <el-form-item label="邮箱状态：">
        <el-select size="small" v-model="formInline.status" style="width:100px" placeholder="请选择">
          <el-option v-for="type in emailStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleAdd">添加</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleExport" title="批量导入用户">用户导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" @click="sendAll" title="批量发送通知消息">发送消息</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50px">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="name" align="center" label="模板名称" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="type" align="center" label="模板类型" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="240px">
        <template slot-scope="scope">
          <el-button size="mini" @click="handlePreview(scope.$index, scope.row)" title="模板预览">预览</el-button>
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" title="模板编辑">编辑</el-button>
          <el-button size="mini" type="danger" @click="delEmail(scope.$index, scope.row)" title="模板删除">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-form-item label="模板名称" prop="name">
          <el-input size="small" v-model="infoForm.name" auto-complete="off" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="模板类型" prop="type">
                <el-radio-group type="kind" v-model="infoForm.type"> 
                    <el-radio v-model="infoForm.type" :label="text">text</el-radio>
                    <el-radio v-model="infoForm.type" :label="html">html</el-radio>
                </el-radio-group>
        </el-form-item> -->
        <el-form-item label="模板内容" prop="content">
                <quill-editor ref="text" v-model="infoForm.content" class="myQuillEditor" :options="editorOption" />
              </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="confirmEditEmail">提交</el-button>
          <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 预览界面 -->
    <el-dialog :title="title" :visible.sync="previewFormVisible" width="60%" @click="closeDialog('perviewForm')">
        <div v-html="tempContent"></div>
    </el-dialog>
  </div>
</template>

<script>
import { getTemplateList, delTemplate, editTemplate } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
//引入富文本 start
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
// import imageResize from 'quill-image-resize-module' // 引用，调整图片大小
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import {regionData,CodeToText,provinceAndCityData} from 'element-china-area-data'

Quill.register('modules/ImageExtend', ImageExtend)

export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      previewFormVisible: false, //控制预览页面显示与隐藏
      title: '用户详情',
      infoForm: {
        id: 0,
        name: '',
        type: '',
        content: '',
      },
       formInline: {
        page: 1,
        ps: 10,
        status: 0
      },
      tempContent: '',
      emailStatus: [
        { key: '全部', value: 0 },
        { key: '已启用', value: 2 },
        { key: '未启用', value: 1 }
      ],
      listData: [], //列表数据
      editorOption: {
        placeholder: "",
        modules: {
          ImageExtend: {
            loading: true,
            name: "file", //图片参数名
            size: 1, // 可选参数 图片大小，单位为M，1M = 1024kb
            action: "https://zlbb.qzhip.com/index.php/index/base/uploadFile", //上传的服务器地址，如果action为空，则采用base64插入图片
            // response 为一个函数，用来获取服务器返回的具体图片地址
            response: res => {
              console.log(res);
              const imgUrl = res.data.url;
              return imgUrl;
            },
            headers: xhr => {
              // 上传图片请求需要携带token的 在xhr.setRequestHeader中设置，这里我的token存放在sessionStorage中
              xhr.setRequestHeader(
                "Token",
                window.localStorage.getItem("token")
              );
            },
            // 可选参数 设置请求头部
            sizeError: () => {}, // 图片超过大小的回调
            start: () => {}, // 可选参数 自定义开始上传触发事件
            end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            error: () => {}, // 可选参数 上传失败触发的事件
            success: () => {
              console.log("ImageExtend中的success：上传成功");
            }, // 可选参数  上传成功触发的事件
            change: (xhr, formData) => {
              // xhr.setRequestHeader('myHeader','myValue')
              // formData.append('token', 'myToken')
            } // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
          },
          // 调整图片大小
          // imageResize: {
					// 	displayStyles: {
					// 		backgroundColor: 'black',
					// 		border: 'none',
					// 		color: 'white'
					// 	},
					// 	modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
					// },
          // 如果不上传图片到服务器，此处不必配置
          toolbar: {
            // container为工具栏，此次引入了全部工具栏，也可自行配置
            container: [
              ['bold', 'italic', 'underline', 'strike'],// 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'],// 引用，代码块
              [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
              [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
              [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
              [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
              [{ 'direction': 'rtl' }], // 文本方向
              [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
              [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
              [{ 'font': [] }], // 字体
              [{ 'align': [] }], // 对齐方式
              ['clean'], //清除字体样式
              ['link','image','video'] //上传图片、上传视频
            ],
            // 上传成功，回显图片（会进入如上面ImageExtend的各过程，返回<img src="http://xx.xx.xx.xx:xxxx/file/xxx.jpg">）
            handlers: {
              image: function() {
                // 劫持原来的图片点击按钮事件
                QuillWatch.emit(this.quill.id);
              }
            }
          }
        }
      },
    
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       // 表单验证
      infoFormRules: {
        name: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入模板内容', trigger: 'blur' }
        ]
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
    quillEditor
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 查询邮箱列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getTemplateList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      // this.formInline.ps = 10,
      this.getdata(this.formInline)
    },
    // 显示添加界面
    handleAdd() {
      this.infoForm.id = 0
      this.infoForm.name = ''
      this.infoForm.type = ''
      this.infoForm.content = ''
      this.title = '添加模板'
      this.editFormVisible = true
    },
    // 显示编辑界面
    handleEdit(index, row) {
      this.infoForm.id = row.id
      this.infoForm.name = row.name
      this.infoForm.type = row.type
      this.infoForm.content = row.content
      this.title = '编辑模板'
      this.editFormVisible = true
    },
    // 显示模板预览界面
    handlePreview(index, row) {
      this.tempContent = row.content
      this.title = '预览模板'
      this.previewFormVisible = true
    },
    // 确认提交邮箱编辑
    confirmEditEmail() {
      let sendData = 'infoForm'
      this.$refs[sendData].validate(valid => {
        if(valid){
          let param = this.infoForm
            editTemplate(param)
            .then(res => {
              if(res.code == 200){
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.editFormVisible = false
                this.getdata(this.formInline)
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('系统错误!')
            })
        }else{
          return false;
        }
    })
    },
    // 删除邮箱
    delEmail(index, row) {
    this.$confirm('确定要删除模板吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {id:row.id}
          delTemplate(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('模板删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'infoForm'){
        this.editFormVisible = false
      }
      this.$refs[formName].resetFields()
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.invite_item {
  height: 600px;
  overflow-y: auto;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/mail/template.vue